import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { LocalStorageConstants } from 'src/app/common/LocalStorageConstants';


@Injectable({
  providedIn: 'root'
})
export class BillService {

  constructor(private http: HttpClient) {
   }

  saveBill(model: any) {
    model.idClient = Number(localStorage.getItem(LocalStorageConstants.CLIENT_ID));
    return this.http.post(environment.apiUrl + 'BillMaster/SaveBillMaster', model);
  }

  GetAllBill():Observable<any>{
    return  this.http.get(environment.apiUrl + 'BillMaster/GetAllBillMaster?idClient=' + Number(localStorage.getItem(LocalStorageConstants.CLIENT_ID)));
  }

  GetPenidngBills():Observable<any>{
    return  this.http.get(environment.apiUrl + 'BillMaster/GetPenidngBills?idClient=' + Number(localStorage.getItem(LocalStorageConstants.CLIENT_ID)));
  }
 
  GetBillById(id):Observable<any>{
    return  this.http.get(environment.apiUrl + 'BillMaster/GetBillMasterById?id='+id);
  }
  
  updateBill(model: any) {
    return this.http.patch(environment.apiUrl + 'BillMaster/UpdateBillMaster', model);
  }

  delete(id: any) {
    return this.http.delete(environment.apiUrl+'BillMaster/Delete?id='+id);
  }

  GetRecentPendingInvoices():Observable<any>{
    return  this.http.get(environment.apiUrl + 'BillMaster/GetRecentPendingBills?idClient=' + Number(localStorage.getItem(LocalStorageConstants.CLIENT_ID)));
  }

  GetSalesDetailsCurrentPreviousMonthYearToday():Observable<any>{
    return  this.http.get(environment.apiUrl + 'BillMaster/GetSalesDetailsCurrentPreviousMonthYearToday?idClient=' + Number(localStorage.getItem(LocalStorageConstants.CLIENT_ID)));
  }
  

}
